module.exports = __webpack_public_path__ + "img/section-bg-1.76abd55c.png";